import React from "react";
import SalesReport from "../modules/SalesReport";

export function SalesReportPage() {
  return <SalesReport />;
}
